exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-edit[data-v-2d67b3d9]{position:relative;padding:5px 6px 0;background:#fff}.form-edit .toolbar[data-v-2d67b3d9]{position:absolute;background:#bdc0c7;padding:0 6px;font-size:10px;top:0;left:0}.form-edit .toolbar .toolbar-icon[data-v-2d67b3d9]{color:#fff;cursor:pointer}.form-edit .block-active[data-v-2d67b3d9]{background:#f56c6c}.form-edit .operator-box[data-v-2d67b3d9]{position:absolute;background:#fff;border:1px solid #eee;border-radius:4px;padding:4px 10px;word-break:keep-all;color:#999}.form-edit .operator-box span[data-v-2d67b3d9]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2d67b3d9","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BoxForm/BoxForm.vue
// module id = 91
// module chunks = 0